import * as yup from 'yup';

export const initialValues = {
	report: null,
	doesntHaveReport: false,
};

const schema = 
yup.object().shape({
	report: yup.mixed(),
	doesntHaveReport: yup.boolean(),
});

export default schema;
